module.exports = __webpack_public_path__ + "static/img/yf_07.a1bc3d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yf/yf_07.jpg
// module id = eB3U
// module chunks = 1